module.exports = __webpack_public_path__ + "img/company-world.f1c0058d.webp";